import { ActionCardModel, QuestionNode } from '@playbooks/action-cards-utils'
import { Question } from '@playbooks/core/src/interfaces/ActionCard'

export default function getQuestionsWithCode(actionCardsModel: ActionCardModel) {
  return actionCardsModel
    .getSearchService()
    .filter(node => node instanceof QuestionNode && !!node.getCode())
    .map(node => node.data) as Question[]
}
